import React, { useState } from 'react'
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@shopflo/ui'
import { Edit, Gift, Paperclip, Plus } from 'react-feather'
import { useCartContext } from 'src/lib/contexts/CartContext'
import { classNames } from 'src/lib/utils/helpers'
import { useLocale } from 'src/lib/hooks/useLocal'
import { CartIcon } from 'src/lib/types/cartUI'

const getCartNoteIcon = (icon: CartIcon) => {
  switch (icon) {
    case 'ATTACH':
      return <Paperclip size={16} />
    case 'EDIT':
      return <Edit size={16} />
    case 'GIFT':
      return <Gift size={16} />
    default:
      return null
  }
}

const CartNotePreview = () => {
  const {
    state: { cartNotes }
  } = useCartContext()
  const { t } = useLocale()

  const [open, setOpen] = useState<string>('')

  if (!cartNotes.enabled) {
    return <></>
  }

  return (
    <div className='w-full border-1 px-3 rounded-xl mt-3'>
      <Accordion type='single' collapsible value={open} onValueChange={setOpen}>
        <AccordionItem value='cart-note'>
          <AccordionTrigger showTriggerIcon={false}>
            <div className='text-base flex gap-2 items-center rounded-xl w-full'>
              {getCartNoteIcon(cartNotes.icon)}
              <h3 className='text-sm font-medium'>{cartNotes.title}</h3>
              <Plus
                className={classNames(
                  `ml-auto h-4 w-4 text-coal-dark `,
                  open ? `rotate-45 transform duration-5 00 ease-in-out` : `rotate-0 transform duration-500 ease-in-out`
                )}
              />
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className='flex flex-col gap-2'>
              <div className='flex w-full flex-col'>
                <textarea
                  className='resize-none p-2 border border-gray-light rounded-lg text-sm scrollbar-hide'
                  style={{ minHeight: '80px' }}
                  placeholder={cartNotes.suggestionText}
                />
              </div>
              <div className='flex gap-2'>
                <button className='p-2 text-carbon rounded-lg px-3 text-sm' onClick={() => setOpen('')}>
                  {t('cancel')}
                </button>
                <button className='bg-primary-dark p-2 text-white rounded-lg px-3 text-sm' disabled={true}>
                  {t('save')}
                </button>
              </div>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  )
}

export default CartNotePreview
